<template>
    <v-select
        auto-select-first
        :label="$t('Model')"
        :items="models"
        item-value="name"
        :value="value"
        @change="onModelChange"
        :menu-props="{ closeOnContentClick: false }"
        :loading="loading"
    >
        <template v-slot:selection="{ item }">
            <div class="d-flex align-center">
                <img
                    v-if="item.logo_url"
                    :src="item.logo_url"
                    :alt="item.name"
                    style="width: 20px; height: 20px; margin-right: 8px; object-fit: contain;"
                />
                <span>{{ item.name }} - {{ item.priceMeasurement }}</span>
            </div>
        </template>

        <template v-slot:item="{ item }">
            <div class="d-flex align-center py-2">
                <img
                    v-if="item.logo_url"
                    :src="item.logo_url"
                    :alt="item.name"
                    style="width: 24px; height: 24px; margin-right: 12px; object-fit: contain;"
                />
                <span>{{ item.name }} - {{ item.priceMeasurement }}</span>
            </div>
        </template>
    </v-select>
</template>

<script>
import DocumentIntelligenceProvidersService from '@/services/DocumentIntelligenceProvidersService.js';
import DocumentIntelligenceProvider from '@/ecm/variables/DocumentIntelligenceProvider.js';

export default {
    name: 'LlmModelSelector',
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            models: [],
            loading: false
        };
    },
    async created() {
        await this.loadModels();
    },
    methods: {
        async loadModels() {
            this.loading = true;
            try {
                const data = await DocumentIntelligenceProvidersService.getLLMModels(DocumentIntelligenceProvider.Infomaniak);
                this.models = data.llmModels;
            } catch (error) {
                console.error('Error loading models:', error);
            } finally {
                this.loading = false;
            }
        },

        onModelChange(selectedModelName) {
            this.$emit('model-changed', selectedModelName);
        }
    }
};
</script>